export enum SaleState {
  None = 0,
  Upcoming,
  Open,
  OutOfSpots,
  OutOfSupply,
  Closed,
}
